<template>
  <v-row class="mr-n5">
    <v-col class="bg-grey-lighten-4" cols="12" >
      <v-card color="grey-lighten-4" class="ma-2" elevation="0">
        <v-card-title class="font-weight-bold text-h5 text-black mb-4">
          Dashboard Overview
        </v-card-title>

        <v-card-text>
          <v-row>
            <!-- Category Cards -->
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-for="(category, i) in computedCategories"
              :key="i"
            >
              <v-card class="pa-3 stat-card" elevation="2" rounded="xl">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div
                      class="text-subtitle-2 font-weight-medium text-grey-darken-2"
                    >
                      {{ category.title }}
                    </div>
                    <div class="text-h6 font-weight-bold mt-2">
                      {{ category.stat }}
                    </div>
                    <div class="text-caption mt-1 text-grey">
                      +10 <span class="text-grey">last month</span>
                    </div>
                  </div>
                  <div>
                    <v-img :src="category.icon" width="24" height="24" />
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- Total Card -->
            <v-col cols="12" sm="6" md="3">
              <v-card
                class="pa-3 stat-card"
                color="red darken-1"
                dark
                rounded="xl"
              >
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="text-subtitle-2 font-weight-medium">
                      Total Listings
                    </div>
                    <div class="text-h6 font-weight-bold mt-2">
                      {{ totalListings }}
                    </div>
                    <div class="text-caption mt-1">+70 last month</div>
                  </div>
                  <div>
                    <v-icon color="white darken-1">mdi-view-dashboard</v-icon>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

// Category info used for display
const rawCategories = [
  {
    title: "Motors",
    icon: require("@/assets/motors.svg"),
    color: "deep-purple lighten-4",
    id: 1,
  },
  {
    title: "Properties For Sale",
    icon: require("@/assets/property-for-sale.svg"),
    color: "cyan lighten-4",
    id: 3,
  },
  {
    title: "Properties For Rent",
    icon: require("@/assets/property-for-rent.svg"),
    color: "cyan lighten-4",
    id: 4,
  },
  {
    title: "Classified",
    icon: require("@/assets/classified.svg"),
    color: "amber lighten-4",
    id: 6,
  },
  {
    title: "Jobs",
    icon: require("@/assets/jobs.svg"),
    color: "light-green lighten-4",
    id: 2,
  },
  {
    title: "Community",
    icon: require("@/assets/community.svg"),
    color: "blue lighten-4",
    id: 5,
  },
  {
    title: "Furniture & Garden",
    icon: require("@/assets/furniture-home-garden.svg"),
    color: "green lighten-4",
    id: 7,
  },
  {
    title: "Mobile & Tablets",
    icon: require("@/assets/mobiles-tablets.svg"),
    color: "orange lighten-4",
    id: 8,
  },
];

// Vuex store access
const store = useStore();

// Get all listings from store (as in your listings component)
const listings = computed(() => store.getters["allListings/allListings"]);

// Dynamically compute count per category
const computedCategories = computed(() =>
  rawCategories.map((cat) => ({
    ...cat,
    stat: listings.value.filter(
      (listing) => listing.category && listing.category.id === cat.id
    ).length,
  }))
);

// Total count of listings
const totalListings = computed(() => listings.value.length);

onMounted(async () => {
  // Fetch listings when component mounts
  await store.dispatch("allListings/fetchAllListings", { all: true });
});

</script>
